import { styled } from '@mui/material';

type Props = {
  children: React.ReactNode;
};

export const ConversationHoverActions = ({ children }: Props) => {
  return (
    <StyledContainer className="message-actions">{children}</StyledContainer>
  );
};

const StyledContainer = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(-4),
  right: theme.spacing(1),
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: theme.shadows[2],
  padding: theme.spacing(0.5, 0.75),
  zIndex: 1,
}));
